import React from 'react';
import { Chip } from '@mui/material';
import { getStatusColor } from 'src/lib/utils';

const formatLabel = (status) => {
  if (!status) return 'Unknown';
  return status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

const OrderStatusChip = ({ status }) => {
  const color = getStatusColor(status);
  const label = formatLabel(status);

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: color,
        color: '#fff',
        fontWeight: 500,
        textTransform: 'capitalize',
      }}
    />
  );
};

export default OrderStatusChip;
